import base_url from '../config';
import axios from 'axios';
import { getErrorMessage, isSafeServerMessage } from '../utils/errors';

const api_url = base_url + 'api/admin/login';

// Uses plain axios (not the shared instance) so a failed sign-in (401) does not
// trigger the global "session expired" redirect.
export const login = async (data) => {
  try {
    const response = await axios.post(api_url, data, { timeout: 30000 });
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const serverMessage = error.response?.data?.message;
    if (status && status < 500 && isSafeServerMessage(serverMessage)) {
      return { error: serverMessage };
    }
    if (status === 401 || status === 403) {
      return { error: 'Invalid username or password.' };
    }
    return { error: getErrorMessage(error, 'Unable to sign in right now. Please try again.') };
  }
};
